/**
 * (c) LBS logics
 *
 *     Mobile Business Technology GmbH
 *     4020 Linz, Austria
 *
 *     www.lbs-logics.com
 *
 *     created on 20190729 by Jan Brunner
 *     all rights reserved.
 */

import { Injectable } from '@angular/core';
import { Resetable } from '../../resetter/resetable';
import { Worktype } from 'src/app/_model/workttype';

@Injectable()
export abstract class WorktypesDaoService implements Resetable {
  public abstract saveWorktypes(worktypes: Worktype[]): Promise<void>;
  public abstract getWorktypes(): Promise<Worktype[]>;
  public abstract reset(): Promise<void>;
  public abstract clear(): Promise<void>;
}
